module.exports = __webpack_public_path__ + "static/img/44.b5166dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/44.png
// module id = NInw
// module chunks = 1